import Compressor from 'compressorjs'

export default function compressImg(propFile, backType = 'file', quality = 0.8,maxWidth=2000) {
  return new Promise((resolve, reject) => {
    new Compressor(propFile, {
      success(result) {
        let file = new File([result], propFile.name, {type: propFile.type})
        if (!backType || backType === 'blob') {
          resolve(result)
        } else if (backType === 'file') {
          resolve(file)
        } else {
          resolve(file)
        }
      },
      quality,
      maxWidth,
      error(err) {
        reject(err)
      },
    });
  })
}
